'use client';

import { useState, useEffect } from 'react';
import { KuikWinkIcon } from '@/components/svg/icons/KuikWinkIcon'

export default function Loading() {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Start fading out after 1.8s (long enough for the typing text to finish).
    const exitTimer = setTimeout(() => setIsExiting(true), 1800);
    // Remove from DOM after fade completes (1800ms + 500ms transition = 2300ms)
    const removeTimer = setTimeout(() => setIsVisible(false), 2300);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div
      className={`loading-overlay ${isExiting ? 'exiting' : ''}`}
      role="status"
      aria-label="Loading"
    >
      <div className="loading-center" aria-hidden="true">
        <div className="loading-arc" />
        <div className="loading-frog">
          <KuikWinkIcon width={45} height={45} />
        </div>
      </div>
      <div className="loading-text-container">
        <p className="typing-text">
          <span className="brand">kuik:</span> Send Money <span className="color-primary">Kuik</span>ly
        </p>
      </div>
    </div>
  )
}
